import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';

import CustomControl from '../../../../../../../../../../../../components/global/CustomControl';
import { IMAGE_SIZE_CODE } from '../../../../../../../../../../../../constants/image-size-codes';
import { getThumbBySize } from '../../../../../../../../../../../../util/photo';
import WatermarkOverlay from '../../../../../../../../../../../../components/global/WatermarkOverlay';

const propTypes = {
  photo: PropTypes.shape({
    id: PropTypes.string.isRequired,
    thumbnail_urls: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        size_code: PropTypes.oneOf(Object.values(IMAGE_SIZE_CODE)),
      }),
    ),
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  isEntitled: PropTypes.bool,
  className: PropTypes.string,
  isSingleGrid: PropTypes.bool,
  watermarkSettings: PropTypes.shape({
    wallpaperCustomText: PropTypes.string,
    wallpaperFontSize: PropTypes.number,
  }),
};

const PhotoSelect = ({
  photo,
  onSelect,
  selected,
  isEntitled,
  className,
  isSingleGrid,
  watermarkSettings,
}) => {
  const classes = classNames({
    'digital-bundle-photo-select': true,
    'is-selected': selected,
    'is-entitled': isEntitled,
    [className]: !!className,
  });

  return (
    <a
      className={classes}
      href="#"
      data-for={`entitled-photo-tooltip-${photo.id}`}
      data-tip="You already own this photo"
      data-effect="solid"
      onClick={event => {
        event.preventDefault();
        onSelect(photo);
      }}
    >
      {isEntitled && (
        <ReactTooltip
          id={`entitled-photo-tooltip-${photo.id}`}
          className="tooltip"
        />
      )}
      {!isEntitled && (
        <CustomControl
          id={photo.id}
          label="Photo Selected"
          labelSrOnly
          type="checkbox"
          checked={!!selected}
          size={isSingleGrid ? 'lg' : 'md'}
          readOnly
        />
      )}

      <div>
        <img
          src={
            getThumbBySize(photo.thumbnail_urls, IMAGE_SIZE_CODE.MEDIUM)?.url
          }
          alt=""
          className="img-block"
        />
        {!isEntitled && !photo?.foreground && (
          <div className="watermark-container">
            <WatermarkOverlay
              text={watermarkSettings?.wallpaperCustomText}
              fontSize={watermarkSettings?.wallpaperFontSize}
              wallpaperMode={watermarkSettings?.wallpaperWatermarkMode}
              imageUrl={watermarkSettings?.wallpaperAssetImage?.url}
            />
          </div>
        )}
      </div>
    </a>
  );
};

PhotoSelect.propTypes = propTypes;

export default PhotoSelect;
